var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('apexchart',{key:_vm.chartKey,attrs:{"height":"350","options":_vm.chartOptions,"series":_vm.chartOptions.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }